import React from 'react';
import { Chip } from '@mui/material';
import {
  Schedule,
  CheckCircle,
  PlayArrow,
  Done,
  Cancel,
  EventBusy,
  Pending,
} from '@mui/icons-material';

interface AppointmentStatusBadgeProps {
  status: 'REQUESTED' | 'SCHEDULED' | 'CONFIRMED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'NO_SHOW';
  size?: 'small' | 'medium';
}

const AppointmentStatusBadge: React.FC<AppointmentStatusBadgeProps> = ({ status, size = 'small' }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'REQUESTED':
        return {
          label: 'Pending',
          color: 'warning' as const,
          icon: <Pending fontSize="small" />,
        };
      case 'SCHEDULED':
        return {
          label: 'Scheduled',
          color: 'info' as const,
          icon: <Schedule fontSize="small" />,
        };
      case 'CONFIRMED':
        return {
          label: 'Confirmed',
          color: 'success' as const,
          icon: <CheckCircle fontSize="small" />,
        };
      case 'IN_PROGRESS':
        return {
          label: 'In Progress',
          color: 'primary' as const,
          icon: <PlayArrow fontSize="small" />,
        };
      case 'COMPLETED':
        return {
          label: 'Completed',
          color: 'success' as const,
          icon: <Done fontSize="small" />,
        };
      case 'CANCELLED':
        return {
          label: 'Cancelled',
          color: 'error' as const,
          icon: <Cancel fontSize="small" />,
        };
      case 'NO_SHOW':
        return {
          label: 'No Show',
          color: 'warning' as const,
          icon: <EventBusy fontSize="small" />,
        };
      default:
        return {
          label: status,
          color: 'default' as const,
          icon: <Schedule fontSize="small" />,
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size={size}
    />
  );
};

export default AppointmentStatusBadge;


